import {createRouter, createWebHistory} from "vue-router"
import {routes} from "./routes"
import {auth} from "@/firebase"
import {useAppStore} from "@/stores/app"
import {useUserStore} from "@/stores/user"
import {useUserRolesStore} from "@/stores/userRoles"
import {useUserPermissionsStore} from "@/stores/userPermissions"
import {useSiteStore} from "@/stores/site"

const router = createRouter({
  history: createWebHistory(),
  routes,
})

const PLATFORM_ONLY_TOOL_ROUTES = new Set([
  "ToolsPosEmulatorView",
  "ToolsQrGeneratorView",
  "ToolsLiftagoMockView",
])

function toolsRouteRedirect(to) {
  if (!PLATFORM_ONLY_TOOL_ROUTES.has(to.name) && to.name !== "ToolsQrScannerView") {
    return null
  }

  const userRolesStore = useUserRolesStore()
  if (userRolesStore.isPlatformAdmin) {
    return null
  }

  const dashboardRedirect = {
    name: "DashboardView",
    params: {siteName: to.params.siteName},
  }

  if (PLATFORM_ONLY_TOOL_ROUTES.has(to.name)) {
    return dashboardRedirect
  }

  const userStore = useUserStore()
  const userPermissionsStore = useUserPermissionsStore()
  const siteStore = useSiteStore()
  const shopId = siteStore.siteShopId
  const shopPermissions = userPermissionsStore.permissions?.shops?.[shopId] || []

  if (
    !userStore.userSelectedSiteId ||
    !shopId ||
    shopPermissions.indexOf("shop.tools.qrscanner") === -1
  ) {
    return dashboardRedirect
  }

  return null
}

router.beforeEach(async (to) => {
  const appStore = useAppStore()
  const userSignedIn = auth.currentUser
  // console.log("router.beforeEach:", to, from, userSignedIn)
  if (!userSignedIn && !["AuthView", "AuthVerifyView"].includes(to.name)) {
    // console.log("router: not allowed, redirecting to Auth")
    return {name: "AuthView"}
  }

  const toolsRedirect = toolsRouteRedirect(to)
  if (toolsRedirect) {
    return toolsRedirect
  }

  // clear floating menu
  appStore.app.floatingMenu = {}
})

export {router}
